import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import LoopOutlinedIcon from '@mui/icons-material/LoopOutlined'
import { Divider, IconButton, Stack, useMediaQuery } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid2'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import { saveAs } from 'file-saver'
import * as React from 'react'
import CloseCircleIcon from '../../../../assets/icons/CloseCircle.svg?react'
import { RightSidebarWrapper } from '../../../../components/Wrapper/RightSidebarWrapper'
import { RecordCreateStateBy } from '../../../../dialogs/RecordCreateStateBy/RecordCreateStateBy'
import { ShareDialog } from '../../../../dialogs/ShareDialog/ShareDialog'
import { useAssistantAdministrationStore } from '../../../../store/storeAssistantAdministration'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { RecordStageStatus, RecordStageType } from '../../../../swagger/dto'
import { theme } from '../../../../theme'
import ShareIcon from './../../../../assets/icons/Share.svg?react'

export const RecordsSetting = () => {
    const [anchor, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const openShare = Boolean(anchor)
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleClickGeneratorTXT = () => {
        const file = new File([memoDetail?.content], 'summary.txt', {
            type: 'text/plain;charset=utf-8',
        })
        saveAs(file)
    }

    const [openMemoShareDialog, setOpenMemoShareDialog] = React.useState<boolean>(false)
    const [openCreateStateByRecordDialog, setOpenCreateStateByRecordDialog] =
        React.useState<boolean>(false)

    const { memoDetail, memoList, record } = useAssistantAdministrationStore((state) => state)
    const { setOpenSidebarType } = useWrapperStore((state) => state)

    const handleClickOpenMemoShareDialog = () => {
        setOpenMemoShareDialog(true)
    }

    const handleCloseMemoShareDialog = () => {
        setOpenMemoShareDialog(false)
    }

    const handleOpenCreateStateByRecordDialog = () => {
        setOpenCreateStateByRecordDialog(true)
    }

    const handleCloseCreateStateByRecordDialog = () => {
        setOpenCreateStateByRecordDialog(false)
    }

    return (
        <RightSidebarWrapper>
            <Grid
                container
                sx={{ height: !isMobile ? `calc(100dvh - ${110}px)` : 'auto', width: '100%' }}>
                <Grid size={12}>
                    <Box
                        sx={{
                            maxHeight: `calc(100dvh - ${120}px)`,
                            overflow: 'auto',
                        }}>
                        <Stack
                            direction="row"
                            sx={{ justifyContent: 'space-between', p: 2, alignItems: 'center' }}>
                            <Typography color="text" variant="h5" sx={{ fontWeight: 500 }}>
                                Настройки расшифровки
                            </Typography>
                            <IconButton
                                sx={{ height: '40px', padding: 0 }}
                                variant="text"
                                onClick={() => setOpenSidebarType(null)}>
                                <CloseCircleIcon />
                            </IconButton>
                        </Stack>
                        <Divider />

                        <Box sx={{ mt: 6, px: '16px' }}>
                            <>
                                <Box
                                    sx={{ maxHeight: `calc(100dvh - ${120}px)`, overflow: 'auto' }}>
                                    <Box>
                                        <>
                                            <Button
                                                disabled={
                                                    !memoDetail ||
                                                    record?.is_archived === true ||
                                                    record?.last_stage?.status ===
                                                        RecordStageStatus['ERROR']
                                                }
                                                onClick={handleClickOpenMemoShareDialog}
                                                fullWidth
                                                variant="contained"
                                                color="primary"
                                                startIcon={<ShareIcon />}
                                                sx={{
                                                    position: 'flex',
                                                    marginLeft: 'auto',
                                                    mb: '24px',
                                                }}>
                                                Поделиться саммари
                                            </Button>

                                            <Button
                                                disabled={
                                                    !memoList ||
                                                    memoList.length > 2 ||
                                                    record?.is_archived === true ||
                                                    !(
                                                        record?.last_stage?.status ===
                                                            RecordStageStatus['COMPLETED'] &&
                                                        record?.last_stage?.stage_type ===
                                                            RecordStageType['MEMO']
                                                    )
                                                }
                                                onClick={handleOpenCreateStateByRecordDialog}
                                                fullWidth
                                                variant="contained"
                                                color="primary"
                                                startIcon={<LoopOutlinedIcon />}
                                                sx={{
                                                    position: 'flex',
                                                    marginLeft: 'auto',
                                                    mb: '12px',
                                                }}>
                                                Перегенерировать
                                            </Button>
                                            <Button
                                                disabled={
                                                    !memoDetail ||
                                                    record?.is_archived === true ||
                                                    record?.last_stage?.status ===
                                                        RecordStageStatus['ERROR']
                                                }
                                                aria-controls={openShare ? 'basic-menu' : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={openShare ? 'true' : undefined}
                                                onClick={handleClick}
                                                fullWidth
                                                variant="contained"
                                                color="primary"
                                                startIcon={<FileUploadOutlinedIcon />}
                                                sx={{
                                                    position: 'flex',
                                                    marginLeft: 'auto',
                                                    mb: '24px',
                                                }}>
                                                Экспорт саммари
                                            </Button>
                                            {memoDetail && (
                                                <Card
                                                    variant="outlined"
                                                    sx={{
                                                        position: 'relative',
                                                        background: '#F9FAFB',
                                                        mt: 3,
                                                        p: '12px',
                                                        borderRadius: '20px',
                                                        overflow: 'visible',
                                                        paddingBottom: '32px',
                                                    }}>
                                                    <Typography
                                                        variant="caption2"
                                                        component="div"
                                                        mb={2}
                                                        sx={{
                                                            fontWeight: 600,
                                                            color: ' #5E626E',
                                                            lineHeight: '16px',
                                                        }}>
                                                        Контекст
                                                    </Typography>
                                                    <Typography
                                                        variant="caption2"
                                                        component="div"
                                                        mb={2}
                                                        sx={{
                                                            fontSize: '12px',
                                                            lineHeight: '16px',
                                                            textAlign: 'left',
                                                        }}>
                                                        {memoDetail.settings.extra_context ?? 'Нет'}
                                                    </Typography>{' '}
                                                </Card>
                                            )}
                                        </>

                                        <Menu
                                            id="basic-menu"
                                            anchorEl={anchor}
                                            open={openShare}
                                            onClose={handleClose}
                                            MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                            }}>
                                            <MenuItem
                                                sx={{
                                                    width: '260px',
                                                    textAlign: 'center',
                                                    maxWidth: '100%',
                                                    mt: 0,
                                                }}
                                                onClick={() => handleClickGeneratorTXT()}>
                                                TXT
                                            </MenuItem>
                                        </Menu>
                                    </Box>
                                </Box>
                            </>

                            <ShareDialog
                                open={openMemoShareDialog}
                                onClose={handleCloseMemoShareDialog}
                                entityId={memoDetail?.id}
                                entityName="summary"
                                title="Поделиться саммари"
                            />

                            <RecordCreateStateBy
                                open={openCreateStateByRecordDialog}
                                handleClose={handleCloseCreateStateByRecordDialog}
                                id={memoDetail?.id}
                            />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </RightSidebarWrapper>
    )
}
